module.exports = __webpack_public_path__ + "static/img/banner.94cf039c.jpg";